import { ChangeRecipeMockup } from "./../../Mockups/ChangeRecipeMockup";
import Config from "../../Configs";
import {
  loginResponseMockup,
  registerResponseMockup,
  registrationDataResponseMock,
  confirmEmailResponseMockup,
  resendEmailResponseMockup,
  homePageDataResponseMockup,
  saveItemMockup,
  calculateCustomizedSolutionProductMockup,
  calculateRecommendedSolutionProductMockup,
  GetAllRawMaterialsMockup,
  AddRawMaterialsMockup,
} from "../../Mockups";
import { ApiResponse } from "../../Models";
import { TimeUtils } from "../../Utils";
import { IHttpService } from "./IHttpService";

export default class MockHttpService implements IHttpService {
  async get<T>(path: string): Promise<ApiResponse<T>> {
    const response = await this.sendRequest<T>("GET", path);
    return <ApiResponse<T>>response;
  }

  async post<T>(path: string, body: any): Promise<ApiResponse<T>> {
    const response = await this.sendRequest<T>("POST", path, body);
    return <ApiResponse<T>>response;
  }

  async patch<T>(path: string, body: any): Promise<ApiResponse<T>> {
    const response = await this.sendRequest<T>("PATCH", path, body);
    return <ApiResponse<T>>response;
  }

  async delete<T>(path: string): Promise<ApiResponse<T>> {
    const response = await this.sendRequest<T>("DELETE", path);
    return <ApiResponse<T>>response;
  }

  setUserIdentifier(userIdentifier: string) {
    //
  }

  private async sendRequest<T>(method: "GET" | "POST" | "PATCH" | "DELETE", path: string, payload?: any): Promise<any> {
    await TimeUtils.sleep(200);
    const cleanPath = path.split("?")[0];

    switch (cleanPath) {
      case Config.apiPaths.login:
        return loginResponseMockup;
      case Config.apiPaths.register:
        return registerResponseMockup;
      case Config.apiPaths.registrationData:
        return registrationDataResponseMock;
      case Config.apiPaths.confirmEmail:
        return confirmEmailResponseMockup;
      case Config.apiPaths.resendEmail:
        return resendEmailResponseMockup;
      case Config.apiPaths.homePageData:
        return homePageDataResponseMockup;
      case Config.apiPaths.saveItem:
        return saveItemMockup;
      case Config.apiPaths.calculateCustomizedSolutionProduct:
        return calculateCustomizedSolutionProductMockup;
      case Config.apiPaths.calculateRecommendedSolutionProduct:
        return calculateRecommendedSolutionProductMockup;
      case Config.apiPaths.getRawMaterials:
        return GetAllRawMaterialsMockup;
      case Config.apiPaths.addRawMaterials:
        return AddRawMaterialsMockup;
      case Config.apiPaths.changeRecipe:
        return ChangeRecipeMockup;
    }
  }
}
